import React from "react";
import { EuiEmptyPrompt } from "@elastic/eui";

export default function () {
    return (
        <EuiEmptyPrompt
            iconType="editorStrike"
            title={<h2>Un Authorized Action</h2>}
            body={
                <>
                    <p>You seem to do not have the permission to do this action</p>
                    <p>Please, ask the admin to give you access</p>
                </>
            }
        />
    );
}
